// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── Base container (unchanged) ───────────────────────────────── */
.payment-section {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}
.payment-container {
  position: relative;            /* ← needed for the badge */
  background: #161b22;
  border: 1px solid #30363d;
  border-radius: 8px;
  padding: 24px;
  width: 100%;
  max-width: 500px;
  color: #c9d1d9;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0,0,0,0.6);
}

/* ─── Best Offer badge ───────────────────────────────────────────── */
.best-offer-badge {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  background: #f9d71c;           /* golden highlight */
  color: #000;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 0.9em;
  font-weight: bold;
  box-shadow: 0 2px 4px rgba(0,0,0,0.3);
  z-index: 1;
}

/* ─── Rest of your existing styles ──────────────────────────────── */
.payment-container h2 {
  margin-bottom: 8px;
  color: #58a6ff;
  font-size: 1.5em;
}
.payment-container p {
  margin-bottom: 16px;
  color: #8b949e;
  font-size: 0.95em;
  line-height: 1.4;
}
.payment-details {
  background: #0d1117;
  border: 1px solid #30363d;
  border-radius: 6px;
  padding: 16px;
  margin-top: 12px;
}
.price-info {
  display: flex;
  justify-content: center;
  align-items: baseline;
  margin-bottom: 12px;
}
.price-info .price {
  font-size: 2em;
  font-weight: bold;
  color: #238636;
  margin-right: 6px;
}
.price-info .per-text {
  font-size: 1em;
  color: #8b949e;
}
.payment-description p {
  margin: 12px 0;
  line-height: 1.5;
  color: #8b949e;
  font-size: 0.9em;
}
.payment-button {
  display: inline-block;
  background: #58a6ff;
  color: #fff;
  padding: 10px 24px;
  border-radius: 4px;
  font-weight: bold;
  text-decoration: none;
  transition: background 0.2s;
  margin-top: 8px;
}
.payment-button:hover {
  background: #3a7bcc;
}
`, "",{"version":3,"sources":["webpack://./src/components/PaymentSection.css"],"names":[],"mappings":"AAAA,qEAAqE;AACrE;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,kBAAkB,aAAa,2BAA2B;EAC1D,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA,uEAAuE;AACvE;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,mBAAmB,YAAY,qBAAqB;EACpD,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;EACrC,UAAU;AACZ;;AAEA,sEAAsE;AACtE;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB","sourcesContent":["/* ─── Base container (unchanged) ───────────────────────────────── */\n.payment-section {\n  display: flex;\n  justify-content: center;\n  margin: 20px 0;\n}\n.payment-container {\n  position: relative;            /* ← needed for the badge */\n  background: #161b22;\n  border: 1px solid #30363d;\n  border-radius: 8px;\n  padding: 24px;\n  width: 100%;\n  max-width: 500px;\n  color: #c9d1d9;\n  text-align: center;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.6);\n}\n\n/* ─── Best Offer badge ───────────────────────────────────────────── */\n.best-offer-badge {\n  position: absolute;\n  top: -12px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: #f9d71c;           /* golden highlight */\n  color: #000;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 0.9em;\n  font-weight: bold;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.3);\n  z-index: 1;\n}\n\n/* ─── Rest of your existing styles ──────────────────────────────── */\n.payment-container h2 {\n  margin-bottom: 8px;\n  color: #58a6ff;\n  font-size: 1.5em;\n}\n.payment-container p {\n  margin-bottom: 16px;\n  color: #8b949e;\n  font-size: 0.95em;\n  line-height: 1.4;\n}\n.payment-details {\n  background: #0d1117;\n  border: 1px solid #30363d;\n  border-radius: 6px;\n  padding: 16px;\n  margin-top: 12px;\n}\n.price-info {\n  display: flex;\n  justify-content: center;\n  align-items: baseline;\n  margin-bottom: 12px;\n}\n.price-info .price {\n  font-size: 2em;\n  font-weight: bold;\n  color: #238636;\n  margin-right: 6px;\n}\n.price-info .per-text {\n  font-size: 1em;\n  color: #8b949e;\n}\n.payment-description p {\n  margin: 12px 0;\n  line-height: 1.5;\n  color: #8b949e;\n  font-size: 0.9em;\n}\n.payment-button {\n  display: inline-block;\n  background: #58a6ff;\n  color: #fff;\n  padding: 10px 24px;\n  border-radius: 4px;\n  font-weight: bold;\n  text-decoration: none;\n  transition: background 0.2s;\n  margin-top: 8px;\n}\n.payment-button:hover {\n  background: #3a7bcc;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
